import { Outlet } from 'react-router';

import { ForbiddenState } from '@shared/ui/states';
import { useHasEveryPermission } from '@shared/session/use-session';

/**
 * Restringe una rama de rutas a quien tenga los permisos indicados.
 *
 * Esto es COMODIDAD, no seguridad. Evita que alguien navegue a una pantalla
 * que se llenaria de errores 403, y nada mas. La autorizacion real vive en el
 * backend, que lee los permisos del token firmado y jamas de lo que envie el
 * cliente: quien quiera llamar al endpoint directamente podra hacerlo, y sera
 * el servidor quien lo rechace.
 *
 * La semantica es Y -se exigen TODOS-, igual que el guard del backend. Que
 * ambos lados coincidan importa: si aqui bastara con uno, la interfaz dejaria
 * entrar a pantallas que despues no funcionan.
 */
export function RequirePermission({ permissions }: { permissions: readonly string[] }) {
  const permitido = useHasEveryPermission(permissions);

  if (!permitido) return <ForbiddenState />;

  return <Outlet />;
}
